import { SharedModule } from '@aiwyn/shared';
import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-request-files-confirmation',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './request-files-confirmation.component.html',
  styleUrl: './request-files-confirmation.component.scss',
})
export class RequestFilesConfirmationComponent {
  submittedFileCount = input.required<number>();
  firmName = input.required<string>();

  uploadMore = output<void>();
}
